import { render } from "./Tables.vue?vue&type=template&id=d918649c&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"

import "./Tables.vue?vue&type=style&index=0&id=d918649c&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/SANDRACANIZAREZ/mi-stock-sandracanizares-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d918649c"]])

export default __exports__